var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenu = function SvgMenu(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 502.4C1.3 563.7 52 612.3 113.3 611s109.9-52.1 108.6-113.3C220.6 437 170.7 388.6 110 389.1 48.5 390.2-.7 440.8 0 502.4m389.2 0c1.4 61.2 52.2 109.6 113.3 108.1 61.2-1.4 109.6-52.2 108.1-113.3-1.4-60.4-51-108.6-111.4-108.2-61.5 1.1-110.6 51.8-110 113.4m389.3 0c1.4 61.2 52.2 109.6 113.3 108.1 61.2-1.4 109.6-52.2 108.1-113.3-1.4-60.4-51-108.6-111.4-108.2-61.6 1.1-110.7 51.8-110 113.4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export default ForwardRef;